const allCountries = [
    {
        "name": "Malaysia",
        "code": "my",
        "official": "Malaysia"
    },
    {
        "name": "Singapore",
        "code": "sg",
        "official": "Republic of Singapore"
    },
    {
        "name": "Indonesia",
        "code": "id",
        "official": "Republic of Indonesia"
    },
    {
        "name": "Brunei",
        "code": "bn",
        "official": "Nation of Brunei, Abode of Peace"
    },
    {
        "name": "Thailand",
        "code": "th",
        "official": "Kingdom of Thailand"
    },
    {
        "name": "Philippines",
        "code": "ph",
        "official": "Republic of the Philippines"
    },
    {
        "name": "Vietnam",
        "code": "vn",
        "official": "Socialist Republic of Vietnam"
    },
    {
        "name": "Myanmar",
        "code": "mm",
        "official": "Republic of the Union of Myanmar"
    },
    {
        "name": "Laos",
        "code": "la",
        "official": "Lao People's Democratic Republic"
    },
    {
        "name": "Cambodia",
        "code": "kh",
        "official": "Kingdom of Cambodia"
    },
    {
        "name": "Afghanistan",
        "code": "af",
        "official": "Islamic Republic of Afghanistan"
    },
    {
        "name": "Åland Islands",
        "code": "ax",
        "official": "Åland Islands"
    },
    {
        "name": "Albania",
        "code": "al",
        "official": "Republic of Albania"
    },
    {
        "name": "Algeria",
        "code": "dz",
        "official": "People's Democratic Republic of Algeria"
    },
    {
        "name": "American Samoa",
        "code": "as",
        "official": "American Samoa"
    },
    {
        "name": "Andorra",
        "code": "ad",
        "official": "Principality of Andorra"
    },
    {
        "name": "Angola",
        "code": "ao",
        "official": "Republic of Angola"
    },
    {
        "name": "Anguilla",
        "code": "ai",
        "official": "Anguilla"
    },
    {
        "name": "Antarctica",
        "official": "Antarctica"
    },
    {
        "name": "Antigua and Barbuda",
        "code": "ag",
        "official": "Antigua and Barbuda"
    },
    {
        "name": "Argentina",
        "code": "ar",
        "official": "Argentine Republic"
    },
    {
        "name": "Armenia",
        "code": "am",
        "official": "Republic of Armenia"
    },
    {
        "name": "Aruba",
        "code": "aw",
        "official": "Aruba"
    },
    {
        "name": "Australia",
        "code": "au",
        "official": "Commonwealth of Australia"
    },
    {
        "name": "Austria",
        "code": "at",
        "official": "Republic of Austria"
    },
    {
        "name": "Azerbaijan",
        "code": "az",
        "official": "Republic of Azerbaijan"
    },
    {
        "name": "Bahamas",
        "code": "bs",
        "official": "Commonwealth of the Bahamas"
    },
    {
        "name": "Bahrain",
        "code": "bh",
        "official": "Kingdom of Bahrain"
    },
    {
        "name": "Bangladesh",
        "code": "bd",
        "official": "People's Republic of Bangladesh"
    },
    {
        "name": "Barbados",
        "code": "bb",
        "official": "Barbados"
    },
    {
        "name": "Belarus",
        "code": "by",
        "official": "Republic of Belarus"
    },
    {
        "name": "Belgium",
        "code": "be",
        "official": "Kingdom of Belgium"
    },
    {
        "name": "Belize",
        "code": "bz",
        "official": "Belize"
    },
    {
        "name": "Benin",
        "code": "bj",
        "official": "Republic of Benin"
    },
    {
        "name": "Bermuda",
        "code": "bm",
        "official": "Bermuda"
    },
    {
        "name": "Bhutan",
        "code": "bt",
        "official": "Kingdom of Bhutan"
    },
    {
        "name": "Bolivia",
        "code": "bo",
        "official": "Plurinational State of Bolivia"
    },
    {
        "name": "Bosnia and Herzegovina",
        "code": "ba",
        "official": "Bosnia and Herzegovina"
    },
    {
        "name": "Botswana",
        "code": "bw",
        "official": "Republic of Botswana"
    },
    {
        "name": "Bouvet Island",
        "official": "Bouvet Island"
    },
    {
        "name": "Brazil",
        "code": "br",
        "official": "Federative Republic of Brazil"
    },
    {
        "name": "British Indian Ocean Territory",
        "code": "io",
        "official": "British Indian Ocean Territory"
    },
    {
        "name": "British Virgin Islands",
        "code": "vg",
        "official": "Virgin Islands"
    },
    {
        "name": "Bulgaria",
        "code": "bg",
        "official": "Republic of Bulgaria"
    },
    {
        "name": "Burkina Faso",
        "code": "bf",
        "official": "Burkina Faso"
    },
    {
        "name": "Burundi",
        "code": "bi",
        "official": "Republic of Burundi"
    },
    {
        "name": "Cameroon",
        "code": "cm",
        "official": "Republic of Cameroon"
    },
    {
        "name": "Canada",
        "code": "ca",
        "official": "Canada"
    },
    {
        "name": "Cape Verde",
        "code": "cv",
        "official": "Republic of Cabo Verde"
    },
    {
        "name": "Caribbean Netherlands",
        "code": "bq",
        "official": "Bonaire, Sint Eustatius and Saba"
    },
    {
        "name": "Cayman Islands",
        "code": "ky",
        "official": "Cayman Islands"
    },
    {
        "name": "Central African Republic",
        "code": "cf",
        "official": "Central African Republic"
    },
    {
        "name": "Chad",
        "code": "td",
        "official": "Republic of Chad"
    },
    {
        "name": "Chile",
        "code": "cl",
        "official": "Republic of Chile"
    },
    {
        "name": "China",
        "code": "cn",
        "official": "People's Republic of China"
    },
    {
        "name": "Christmas Island",
        "code": "cx",
        "official": "Territory of Christmas Island"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "code": "cc",
        "official": "Territory of the Cocos (Keeling) Islands"
    },
    {
        "name": "Colombia",
        "code": "co",
        "official": "Republic of Colombia"
    },
    {
        "name": "Comoros",
        "code": "km",
        "official": "Union of the Comoros"
    },
    {
        "name": "Cook Islands",
        "code": "ck",
        "official": "Cook Islands"
    },
    {
        "name": "Costa Rica",
        "code": "cr",
        "official": "Republic of Costa Rica"
    },
    {
        "name": "Croatia",
        "code": "hr",
        "official": "Republic of Croatia"
    },
    {
        "name": "Cuba",
        "code": "cu",
        "official": "Republic of Cuba"
    },
    {
        "name": "Curaçao",
        "code": "cw",
        "official": "Country of Curaçao"
    },
    {
        "name": "Cyprus",
        "code": "cy",
        "official": "Republic of Cyprus"
    },
    {
        "name": "Czechia",
        "official": "Czech Republic"
    },
    {
        "name": "Denmark",
        "code": "dk",
        "official": "Kingdom of Denmark"
    },
    {
        "name": "Djibouti",
        "code": "dj",
        "official": "Republic of Djibouti"
    },
    {
        "name": "Dominica",
        "code": "dm",
        "official": "Commonwealth of Dominica"
    },
    {
        "name": "Dominican Republic",
        "code": "do",
        "official": "Dominican Republic"
    },
    {
        "name": "DR Congo",
        "official": "Democratic Republic of the Congo"
    },
    {
        "name": "Ecuador",
        "code": "ec",
        "official": "Republic of Ecuador"
    },
    {
        "name": "Egypt",
        "code": "eg",
        "official": "Arab Republic of Egypt"
    },
    {
        "name": "El Salvador",
        "code": "sv",
        "official": "Republic of El Salvador"
    },
    {
        "name": "Equatorial Guinea",
        "code": "gq",
        "official": "Republic of Equatorial Guinea"
    },
    {
        "name": "Eritrea",
        "code": "er",
        "official": "State of Eritrea"
    },
    {
        "name": "Estonia",
        "code": "ee",
        "official": "Republic of Estonia"
    },
    {
        "name": "Eswatini",
        "official": "Kingdom of Eswatini"
    },
    {
        "name": "Ethiopia",
        "code": "et",
        "official": "Federal Democratic Republic of Ethiopia"
    },
    {
        "name": "Falkland Islands",
        "code": "fk",
        "official": "Falkland Islands"
    },
    {
        "name": "Faroe Islands",
        "code": "fo",
        "official": "Faroe Islands"
    },
    {
        "name": "Fiji",
        "code": "fj",
        "official": "Republic of Fiji"
    },
    {
        "name": "Finland",
        "code": "fi",
        "official": "Republic of Finland"
    },
    {
        "name": "France",
        "code": "fr",
        "official": "French Republic"
    },
    {
        "name": "French Guiana",
        "code": "gf",
        "official": "Guiana"
    },
    {
        "name": "French Polynesia",
        "code": "pf",
        "official": "French Polynesia"
    },
    {
        "name": "French Southern and Antarctic Lands",
        "official": "Territory of the French Southern and Antarctic Lands"
    },
    {
        "name": "Gabon",
        "code": "ga",
        "official": "Gabonese Republic"
    },
    {
        "name": "Gambia",
        "code": "gm",
        "official": "Republic of the Gambia"
    },
    {
        "name": "Georgia",
        "code": "ge",
        "official": "Georgia"
    },
    {
        "name": "Germany",
        "code": "de",
        "official": "Federal Republic of Germany"
    },
    {
        "name": "Ghana",
        "code": "gh",
        "official": "Republic of Ghana"
    },
    {
        "name": "Gibraltar",
        "code": "gi",
        "official": "Gibraltar"
    },
    {
        "name": "Greece",
        "code": "gr",
        "official": "Hellenic Republic"
    },
    {
        "name": "Greenland",
        "code": "gl",
        "official": "Greenland"
    },
    {
        "name": "Grenada",
        "code": "gd",
        "official": "Grenada"
    },
    {
        "name": "Guadeloupe",
        "code": "gp",
        "official": "Guadeloupe"
    },
    {
        "name": "Guam",
        "code": "gu",
        "official": "Guam"
    },
    {
        "name": "Guatemala",
        "code": "gt",
        "official": "Republic of Guatemala"
    },
    {
        "name": "Guernsey",
        "code": "gg",
        "official": "Bailiwick of Guernsey"
    },
    {
        "name": "Guinea",
        "code": "gq",
        "official": "Republic of Guinea"
    },
    {
        "name": "Guinea-Bissau",
        "code": "gw",
        "official": "Republic of Guinea-Bissau"
    },
    {
        "name": "Guyana",
        "code": "gy",
        "official": "Co-operative Republic of Guyana"
    },
    {
        "name": "Haiti",
        "code": "ht",
        "official": "Republic of Haiti"
    },
    {
        "name": "Heard Island and McDonald Islands",
        "official": "Heard Island and McDonald Islands"
    },
    {
        "name": "Honduras",
        "code": "hn",
        "official": "Republic of Honduras"
    },
    {
        "name": "Hong Kong",
        "code": "hk",
        "official": "Hong Kong Special Administrative Region of the People's Republic of China"
    },
    {
        "name": "Hungary",
        "code": "hu",
        "official": "Hungary"
    },
    {
        "name": "Iceland",
        "code": "is",
        "official": "Iceland"
    },
    {
        "name": "India",
        "code": "io",
        "official": "Republic of India"
    },
    {
        "name": "Iran",
        "code": "ir",
        "official": "Islamic Republic of Iran"
    },
    {
        "name": "Iraq",
        "code": "iq",
        "official": "Republic of Iraq"
    },
    {
        "name": "Ireland",
        "code": "ie",
        "official": "Republic of Ireland"
    },
    {
        "name": "Isle of Man",
        "code": "im",
        "official": "Isle of Man"
    },
    {
        "name": "Israel",
        "code": "il",
        "official": "State of Israel"
    },
    {
        "name": "Italy",
        "code": "it",
        "official": "Italian Republic"
    },
    {
        "name": "Ivory Coast",
        "official": "Republic of Côte d'Ivoire"
    },
    {
        "name": "Jamaica",
        "code": "jm",
        "official": "Jamaica"
    },
    {
        "name": "Japan",
        "code": "jp",
        "official": "Japan"
    },
    {
        "name": "Jersey",
        "code": "je",
        "official": "Bailiwick of Jersey"
    },
    {
        "name": "Jordan",
        "code": "jo",
        "official": "Hashemite Kingdom of Jordan"
    },
    {
        "name": "Kazakhstan",
        "code": "kz",
        "official": "Republic of Kazakhstan"
    },
    {
        "name": "Kenya",
        "code": "ke",
        "official": "Republic of Kenya"
    },
    {
        "name": "Kiribati",
        "code": "ki",
        "official": "Independent and Sovereign Republic of Kiribati"
    },
    {
        "name": "Kosovo",
        "code": "xk",
        "official": "Republic of Kosovo"
    },
    {
        "name": "Kuwait",
        "code": "kw",
        "official": "State of Kuwait"
    },
    {
        "name": "Kyrgyzstan",
        "code": "kg",
        "official": "Kyrgyz Republic"
    },
    {
        "name": "Latvia",
        "code": "lv",
        "official": "Republic of Latvia"
    },
    {
        "name": "Lebanon",
        "code": "lb",
        "official": "Lebanese Republic"
    },
    {
        "name": "Lesotho",
        "code": "ls",
        "official": "Kingdom of Lesotho"
    },
    {
        "name": "Liberia",
        "code": "lr",
        "official": "Republic of Liberia"
    },
    {
        "name": "Libya",
        "code": "ly",
        "official": "State of Libya"
    },
    {
        "name": "Liechtenstein",
        "code": "li",
        "official": "Principality of Liechtenstein"
    },
    {
        "name": "Lithuania",
        "code": "lt",
        "official": "Republic of Lithuania"
    },
    {
        "name": "Luxembourg",
        "code": "lu",
        "official": "Grand Duchy of Luxembourg"
    },
    {
        "name": "Macau",
        "code": "mo",
        "official": "Macao Special Administrative Region of the People's Republic of China"
    },
    {
        "name": "Madagascar",
        "code": "mg",
        "official": "Republic of Madagascar"
    },
    {
        "name": "Malawi",
        "code": "mw",
        "official": "Republic of Malawi"
    },
    {
        "name": "Maldives",
        "code": "mv",
        "official": "Republic of the Maldives"
    },
    {
        "name": "Mali",
        "code": "ml",
        "official": "Republic of Mali"
    },
    {
        "name": "Malta",
        "code": "mt",
        "official": "Republic of Malta"
    },
    {
        "name": "Marshall Islands",
        "code": "mh",
        "official": "Republic of the Marshall Islands"
    },
    {
        "name": "Martinique",
        "code": "mq",
        "official": "Martinique"
    },
    {
        "name": "Mauritania",
        "code": "mr",
        "official": "Islamic Republic of Mauritania"
    },
    {
        "name": "Mauritius",
        "code": "mu",
        "official": "Republic of Mauritius"
    },
    {
        "name": "Mayotte",
        "code": "yt",
        "official": "Department of Mayotte"
    },
    {
        "name": "Mexico",
        "code": "mx",
        "official": "United Mexican States"
    },
    {
        "name": "Micronesia",
        "code": "fm",
        "official": "Federated States of Micronesia"
    },
    {
        "name": "Moldova",
        "code": "md",
        "official": "Republic of Moldova"
    },
    {
        "name": "Monaco",
        "code": "mc",
        "official": "Principality of Monaco"
    },
    {
        "name": "Mongolia",
        "code": "mn",
        "official": "Mongolia"
    },
    {
        "name": "Montenegro",
        "code": "me",
        "official": "Montenegro"
    },
    {
        "name": "Montserrat",
        "code": "ms",
        "official": "Montserrat"
    },
    {
        "name": "Morocco",
        "code": "ma",
        "official": "Kingdom of Morocco"
    },
    {
        "name": "Mozambique",
        "code": "mz",
        "official": "Republic of Mozambique"
    },
    {
        "name": "Namibia",
        "code": "na",
        "official": "Republic of Namibia"
    },
    {
        "name": "Nauru",
        "code": "nr",
        "official": "Republic of Nauru"
    },
    {
        "name": "Nepal",
        "code": "np",
        "official": "Federal Democratic Republic of Nepal"
    },
    {
        "name": "Netherlands",
        "code": "bq",
        "official": "Kingdom of the Netherlands"
    },
    {
        "name": "New Caledonia",
        "code": "nc",
        "official": "New Caledonia"
    },
    {
        "name": "New Zealand",
        "code": "nz",
        "official": "New Zealand"
    },
    {
        "name": "Nicaragua",
        "code": "ni",
        "official": "Republic of Nicaragua"
    },
    {
        "name": "Niger",
        "code": "ne",
        "official": "Republic of Niger"
    },
    {
        "name": "Nigeria",
        "code": "ng",
        "official": "Federal Republic of Nigeria"
    },
    {
        "name": "Niue",
        "code": "nu",
        "official": "Niue"
    },
    {
        "name": "Norfolk Island",
        "code": "nf",
        "official": "Territory of Norfolk Island"
    },
    {
        "name": "North Korea",
        "code": "kp",
        "official": "Democratic People's Republic of Korea"
    },
    {
        "name": "North Macedonia",
        "official": "Republic of North Macedonia"
    },
    {
        "name": "Northern Mariana Islands",
        "code": "mp",
        "official": "Commonwealth of the Northern Mariana Islands"
    },
    {
        "name": "Norway",
        "code": "no",
        "official": "Kingdom of Norway"
    },
    {
        "name": "Oman",
        "code": "om",
        "official": "Sultanate of Oman"
    },
    {
        "name": "Pakistan",
        "code": "pk",
        "official": "Islamic Republic of Pakistan"
    },
    {
        "name": "Palau",
        "code": "pw",
        "official": "Republic of Palau"
    },
    {
        "name": "Palestine",
        "code": "ps",
        "official": "State of Palestine"
    },
    {
        "name": "Panama",
        "code": "pa",
        "official": "Republic of Panama"
    },
    {
        "name": "Papua New Guinea",
        "code": "pg",
        "official": "Independent State of Papua New Guinea"
    },
    {
        "name": "Paraguay",
        "code": "py",
        "official": "Republic of Paraguay"
    },
    {
        "name": "Peru",
        "code": "pe",
        "official": "Republic of Peru"
    },
    {
        "name": "Pitcairn Islands",
        "official": "Pitcairn Group of Islands"
    },
    {
        "name": "Poland",
        "code": "pl",
        "official": "Republic of Poland"
    },
    {
        "name": "Portugal",
        "code": "pt",
        "official": "Portuguese Republic"
    },
    {
        "name": "Puerto Rico",
        "code": "pr",
        "official": "Commonwealth of Puerto Rico"
    },
    {
        "name": "Qatar",
        "code": "qa",
        "official": "State of Qatar"
    },
    {
        "name": "Republic of the Congo",
        "official": "Republic of the Congo"
    },
    {
        "name": "Réunion",
        "code": "re",
        "official": "Réunion Island"
    },
    {
        "name": "Romania",
        "code": "ro",
        "official": "Romania"
    },
    {
        "name": "Russia",
        "code": "ru",
        "official": "Russian Federation"
    },
    {
        "name": "Rwanda",
        "code": "rw",
        "official": "Republic of Rwanda"
    },
    {
        "name": "Saint Barthélemy",
        "code": "bl",
        "official": "Collectivity of Saint Barthélemy"
    },
    {
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "official": "Saint Helena, Ascension and Tristan da Cunha"
    },
    {
        "name": "Saint Kitts and Nevis",
        "code": "kn",
        "official": "Federation of Saint Christopher and Nevis"
    },
    {
        "name": "Saint Lucia",
        "code": "lc",
        "official": "Saint Lucia"
    },
    {
        "name": "Saint Martin",
        "code": "mf",
        "official": "Saint Martin"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "code": "pm",
        "official": "Saint Pierre and Miquelon"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "code": "vc",
        "official": "Saint Vincent and the Grenadines"
    },
    {
        "name": "Samoa",
        "code": "as",
        "official": "Independent State of Samoa"
    },
    {
        "name": "San Marino",
        "code": "sm",
        "official": "Republic of San Marino"
    },
    {
        "name": "São Tomé and Príncipe",
        "code": "st",
        "official": "Democratic Republic of São Tomé and Príncipe"
    },
    {
        "name": "Saudi Arabia",
        "code": "sa",
        "official": "Kingdom of Saudi Arabia"
    },
    {
        "name": "Senegal",
        "code": "sn",
        "official": "Republic of Senegal"
    },
    {
        "name": "Serbia",
        "code": "rs",
        "official": "Republic of Serbia"
    },
    {
        "name": "Seychelles",
        "code": "sc",
        "official": "Republic of Seychelles"
    },
    {
        "name": "Sierra Leone",
        "code": "sl",
        "official": "Republic of Sierra Leone"
    },
    {
        "name": "Sint Maarten",
        "code": "sx",
        "official": "Sint Maarten"
    },
    {
        "name": "Slovakia",
        "code": "sk",
        "official": "Slovak Republic"
    },
    {
        "name": "Slovenia",
        "code": "si",
        "official": "Republic of Slovenia"
    },
    {
        "name": "Solomon Islands",
        "code": "sb",
        "official": "Solomon Islands"
    },
    {
        "name": "Somalia",
        "code": "so",
        "official": "Federal Republic of Somalia"
    },
    {
        "name": "South Africa",
        "code": "za",
        "official": "Republic of South Africa"
    },
    {
        "name": "South Georgia",
        "official": "South Georgia and the South Sandwich Islands"
    },
    {
        "name": "South Korea",
        "code": "kr",
        "official": "Republic of Korea"
    },
    {
        "name": "South Sudan",
        "code": "ss",
        "official": "Republic of South Sudan"
    },
    {
        "name": "Spain",
        "code": "es",
        "official": "Kingdom of Spain"
    },
    {
        "name": "Sri Lanka",
        "code": "lk",
        "official": "Democratic Socialist Republic of Sri Lanka"
    },
    {
        "name": "Sudan",
        "code": "ss",
        "official": "Republic of the Sudan"
    },
    {
        "name": "Suriname",
        "code": "sr",
        "official": "Republic of Suriname"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "code": "sj",
        "official": "Svalbard og Jan Mayen"
    },
    {
        "name": "Sweden",
        "code": "se",
        "official": "Kingdom of Sweden"
    },
    {
        "name": "Switzerland",
        "code": "ch",
        "official": "Swiss Confederation"
    },
    {
        "name": "Syria",
        "code": "sy",
        "official": "Syrian Arab Republic"
    },
    {
        "name": "Taiwan",
        "code": "tw",
        "official": "Republic of China (Taiwan)"
    },
    {
        "name": "Tajikistan",
        "code": "tj",
        "official": "Republic of Tajikistan"
    },
    {
        "name": "Tanzania",
        "code": "tz",
        "official": "United Republic of Tanzania"
    },
    {
        "name": "Timor-Leste",
        "code": "tl",
        "official": "Democratic Republic of Timor-Leste"
    },
    {
        "name": "Togo",
        "code": "tg",
        "official": "Togolese Republic"
    },
    {
        "name": "Tokelau",
        "code": "tk",
        "official": "Tokelau"
    },
    {
        "name": "Tonga",
        "code": "to",
        "official": "Kingdom of Tonga"
    },
    {
        "name": "Trinidad and Tobago",
        "code": "tt",
        "official": "Republic of Trinidad and Tobago"
    },
    {
        "name": "Tunisia",
        "code": "tn",
        "official": "Tunisian Republic"
    },
    {
        "name": "Turkey",
        "code": "tr",
        "official": "Republic of Turkey"
    },
    {
        "name": "Turkmenistan",
        "code": "tm",
        "official": "Turkmenistan"
    },
    {
        "name": "Turks and Caicos Islands",
        "code": "tc",
        "official": "Turks and Caicos Islands"
    },
    {
        "name": "Tuvalu",
        "code": "tv",
        "official": "Tuvalu"
    },
    {
        "name": "Uganda",
        "code": "ug",
        "official": "Republic of Uganda"
    },
    {
        "name": "Ukraine",
        "code": "ua",
        "official": "Ukraine"
    },
    {
        "name": "United Arab Emirates",
        "code": "ae",
        "official": "United Arab Emirates"
    },
    {
        "name": "United Kingdom",
        "code": "gb",
        "official": "United Kingdom of Great Britain and Northern Ireland"
    },
    {
        "name": "United States",
        "code": "us",
        "official": "United States of America"
    },
    {
        "name": "United States Minor Outlying Islands",
        "official": "United States Minor Outlying Islands"
    },
    {
        "name": "United States Virgin Islands",
        "official": "Virgin Islands of the United States"
    },
    {
        "name": "Uruguay",
        "code": "uy",
        "official": "Oriental Republic of Uruguay"
    },
    {
        "name": "Uzbekistan",
        "code": "uz",
        "official": "Republic of Uzbekistan"
    },
    {
        "name": "Vanuatu",
        "code": "vu",
        "official": "Republic of Vanuatu"
    },
    {
        "name": "Vatican City",
        "code": "va",
        "official": "Vatican City State"
    },
    {
        "name": "Venezuela",
        "code": "ve",
        "official": "Bolivarian Republic of Venezuela"
    },
    {
        "name": "Wallis and Futuna",
        "code": "wf",
        "official": "Territory of the Wallis and Futuna Islands"
    },
    {
        "name": "Western Sahara",
        "code": "eh",
        "official": "Sahrawi Arab Democratic Republic"
    },
    {
        "name": "Yemen",
        "code": "ye",
        "official": "Republic of Yemen"
    },
    {
        "name": "Zambia",
        "code": "zm",
        "official": "Republic of Zambia"
    },
    {
        "name": "Zimbabwe",
        "code": "zw",
        "official": "Republic of Zimbabwe"
    }
]

export const countries = allCountries